import { useEffect, useState } from 'react';
import { getAuthStatus } from '../api';
import { Status } from '../types'

export function useAuth() {
  const [auth, setAuth] = useState<Status>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAuthStatus()
      .then(({ status }) => {
        setAuth(status);
      })
      .catch((err) => {
        console.log(err);
        setError(err);
      })
      .finally(() => setLoading(false))
  }, []);

  return { auth, error, loading };
}